import { RunAssistance, ServiceEnvironment } from '@back4app2/sdk';
import PreDeployPanel from './PreDeployPanel';

/**
 * The pre-deploy panel as a modal, over the app the customer was already
 * looking at.
 *
 * Shown between clicking Deploy and the build starting, and ONLY when there is
 * something to say — a screen that appears on every deploy is a screen people
 * click through without reading, which is worse than no screen.
 *
 * The first build of a new app uses the same panel without this wrapper: there
 * it is a step of the creation flow, not an interruption of it. See
 * `PreDeployPanel`.
 */
const PreDeployConfirmModal = ({
  appId,
  serviceEnvironment,
  runAssistance,
  title = 'Finish your setup',
  proceedLabel,
  skipLabel,
  onCancel,
  onProceed,
}: {
  appId: string;
  serviceEnvironment: ServiceEnvironment;
  /** Absent when a held build outlived the analysis that produced it. */
  runAssistance?: RunAssistance;
  title?: string;
  proceedLabel?: string;
  skipLabel?: string;
  onCancel: () => void;
  onProceed: () => void;
}) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
    <div className="w-full max-w-2xl rounded-[10px] border border-[#283A58] bg-[#17243B] p-6 max-h-[90vh] overflow-y-auto">
      {/* The title lives on the modal, not in the panel: in the wizard the
          card header already names the step, and two titles one under the
          other is what that looked like. A modal has no header of its own. */}
      <h2 className="font-sora text-lg font-bold mb-4">{title}</h2>
      <PreDeployPanel
        appId={appId}
        serviceEnvironment={serviceEnvironment}
        runAssistance={runAssistance}
        proceedLabel={proceedLabel}
        skipLabel={skipLabel}
        onCancel={onCancel}
        onProceed={onProceed}
      />
    </div>
  </div>
);

export default PreDeployConfirmModal;
